export function getBuildNumber(useDefault = true) {
  const env$ = document.head.querySelector(`meta[name='build']`);

  if (useDefault) {
    return env$?.getAttribute('content') ?? new Date().getTime().toString();
  }

  return env$?.getAttribute('content')?.toString();
}
